var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertmanagerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128px",
    height: "128px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.932
    },
    fill: "#c0392b",
    d: "M 55.5,-0.5 C 61.1667,-0.5 66.8333,-0.5 72.5,-0.5C 101.836,5.16841 120.169,22.5017 127.5,51.5C 127.5,59.8333 127.5,68.1667 127.5,76.5C 121.02,102.98 104.686,119.98 78.5,127.5C 68.8333,127.5 59.1667,127.5 49.5,127.5C 22.5098,119.511 5.84314,101.845 -0.5,74.5C -0.5,67.5 -0.5,60.5 -0.5,53.5C 6.69726,23.6365 25.3639,5.63652 55.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e64d3d",
    d: "M 55.5,6.5 C 88.4407,5.29538 109.941,20.2954 120,51.5C 124.201,85.9611 110.035,108.794 77.5,120C 40.8505,125.097 17.3505,109.931 7,74.5C 3.55833,45.5472 14.725,24.3805 40.5,11C 45.6044,9.42411 50.6044,7.92411 55.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eceeef",
    d: "M 88.5,81.5 C 72.0084,82.4965 55.3417,82.8298 38.5,82.5C 39.6382,79.2807 40.4715,75.9474 41,72.5C 41.3333,64.1667 41.6667,55.8333 42,47.5C 44.7016,39.2987 50.2016,33.9653 58.5,31.5C 59.0292,28.7428 60.0292,26.2428 61.5,24C 67.1487,23.8302 69.4821,26.6635 68.5,32.5C 76.5368,34.0269 82.0368,38.6936 85,46.5C 84.8992,58.3516 86.0659,70.0183 88.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e87468",
    d: "M 88.5,81.5 C 89.0431,81.56 89.3764,81.8933 89.5,82.5C 72.338,83.827 55.338,83.827 38.5,82.5C 55.3417,82.8298 72.0084,82.4965 88.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eceff0",
    d: "M 31.5,85.5 C 52.8359,85.3334 74.1693,85.5 95.5,86C 98.1667,88.3333 98.1667,90.6667 95.5,93C 74.1667,93.6667 52.8333,93.6667 31.5,93C 28.9142,90.506 28.9142,88.006 31.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eceaeb",
    d: "M 55.5,96.5 C 60.8333,96.5 66.1667,96.5 71.5,96.5C 69.7961,104.185 65.4627,106.185 58.5,102.5C 56.9617,100.757 55.9617,98.7567 55.5,96.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertmanagerIcon);
export default __webpack_public_path__ + "static/media/AlertmanagerIcon.3ac621f244089e193e27006b116e89ab.svg";
export { ForwardRef as ReactComponent };